/**
 * This is a manual helper typing for the LeaseChange.types[].type (string) type
 */
export enum LeaseChangeType {
  VehicleReturn = 'VehicleReturn',
  ManualSale = 'ManualSale',
  ChangeTermMileage = 'ChangeTerm&Mileage',
}
